<div class="container-fluid p-0">
  <div class="hpanel">
    <div class="panel-body b-r-6">
      <!-- <div class="col-lg-12 p-0"> -->
      <div class="display-flex form-group">
        <div class="back-botton" (click)="goback()">
          <ng-icon name="tablerChevronLeft"></ng-icon>
          Go Back
        </div>
        <div class="breadcumb-flex" *ngIf="breadCrumbsArr?.length > 0">

          <ng-container *ngFor="let bData of breadCrumbsArr; let index = index; let isLast = last">
            <p class="p-0 m-0" [ngClass]="{ active : isLast}" [routerLink]="bData.path" [queryParams]="businessData">
              {{bData.label}}
            </p>
            <p style="margin-bottom: 0px;align-self: end;" *ngIf="!isLast">
              <ng-icon name="tablerChevronRight" style="margin-top: -7px;"></ng-icon>
            </p>
          </ng-container>

        </div>
      </div>

      <div class="col-lg-12 form-group">
        <h6 class="mt-3">{{title}}</h6>
      </div>

      <div class="col-lg-12 mr-bt-20" *ngIf="labelFields?.length > 0; else planCard">
        <div class="row">
          <div [ngStyle]="{ 'margin-bottom' : Iindex > 0 ? '2rem' : '0rem'}" class="col-sm-3"
            *ngFor="let item of labelFields; let Iindex = index">

            <label>{{item.label}}</label>
            <ng-container *ngIf="ownerView && item?.dropdownView ; else Ctemplate">
              <!-- Wrapper provides the positioning context that `.svg-pencil2`
                   (position: absolute) anchors to. Without it the pencil
                   resolves against a far-up ancestor and floats unpredictably. -->
              <div style="position: relative;">
                <ng-content *ngIf="item.label === 'Owner'" select="[Owner]"></ng-content>
                <ng-content *ngIf="item.key === 'type'" select="[type]"></ng-content>
                <ng-content *ngIf="item.key === 'network'" select="[network]"></ng-content>
                <ng-content *ngIf="item.key === 'subContractAllowed'" select="[subContractAllowed]"></ng-content>
                <ng-icon name="tablerPencil" *ngIf="item.key !== 'subContractAllowed' && item.key !== 'type' && parentData && (['CONNECTED', 'INACTIVE','REQUEST_SENT', null, undefined].includes(parentData.connectionStatus))"
                  class="svg-pencil2"></ng-icon>
              </div>
            </ng-container>

            <ng-template #Ctemplate>

              <div *ngIf="parentData!=null && item?.validate; else noValidation" style="position: relative;"
                [title]="item.disabled ? parentData[item?.key] : null">
                <input [formControl]="validationForm[item.key]" (focus)="onFocus(item.key)" (focusout)="focusOut(item)"
                  [ngClass]="getInputClass(item)" class="form-control" [id]="item.key" type="text"
                  [(ngModel)]="parentData[item?.key]" [maxlength]="item?.max + 1" [title]="parentData[item?.key]"
                  >
                <label class="svg-pencil1" for="{{item.key}}">
                  <ng-icon name="tablerPencil" class="svg-pencil1"
                    *ngIf="!item.disabled&&parentData?.b2bNetworkName!='General Network'"></ng-icon>
                </label>
                <ng-container *ngIf="this.parentData[item.key]!=null">
                  <p class="text-danger m-0" *ngIf="validationForm[item.key]?.errors?.required">{{item.requiredText}}
                  </p>
                  <p class="text-danger m-0" *ngIf="validationForm[item.key]?.errors?.minlength">{{item.minText}}</p>
                  <p class="text-danger m-0" *ngIf="validationForm[item.key]?.errors?.maxlength">{{item.maxText}}</p>
                  <p class="text-danger m-0" *ngIf="validationForm[item.key]?.errors?.pattern">{{item.patternText}}</p>
                </ng-container>
              </div>

              <ng-template #noValidation>
                <div *ngIf="parentData!=null " style="position: relative;"
                  [title]="item.disabled ? parentData[item?.key] : null">
                  <input [id]="item.key" (focus)="onFocus(item.key)" (focusout)="focusOut(item)"
                    [ngClass]="getInputClass(item)" class="form-control" type="text" [(ngModel)]="parentData[item?.key]"
                    [title]="parentData[item?.key]" >
                  <label class="svg-pencil1" for="{{item.key}}">
                    <ng-icon name="tablerPencil" *ngIf="!item.disabled&&parentData?.b2bNetworkName!='General Network'"></ng-icon>
                  </label>
                </div>
              </ng-template>


            </ng-template>

          </div>

          <div class="col-sm-3 display-grid">
            <label>Status</label>
            <label class="custom-switch">
              <input [disabled]="isCheckboxDisabled()" type="checkbox" [(ngModel)]="parentActive"
                 (change)="onStatusChange($event.target.checked)">
              <span class="custom-slider"></span>
            </label>
          </div>
        </div>
      </div>

      <ng-template #planCard>
        <div class="col-lg-12">
          <ng-content></ng-content>
        </div>
      </ng-template>

      <div class="manage-template-header">
        <div class="customer-search-container">

          <div class="search-field-input p-0">
            <span class="manage-search-svg-icon">
              <ng-icon name="tablerSearch"></ng-icon>
            </span>
            <input type="text" id="manage-search" class="form-control  search-field-pad" #searchBox
              (keyup)="searchSubject.next(searchBox.value)" [placeholder]="placeHolderData">
          </div>

          <div class="customer-search-filter-btns" yPosition="below" xPosition="after" [matMenuTriggerFor]="menu">
            <button type="button" class="btn btn-primary svg-funnel" id="dropdownManual">
              Filter
              <ng-icon name="tablerFilter"></ng-icon>
            </button>


          </div>
        </div>

      </div>

      <div class="manage-template-height" infiniteScroll [infiniteScrollDistance]="1" [scrollWindow]="false"
        [infiniteScrollThrottle]="500" [alwaysCallback]="true" (scrolled)="onScrollDown()">
        <div class="row" style="gap: 1rem;">
          <div class="col-lg-12 ">

            <ng-container *ngIf="Fields?.length > 0">
              <table>
                <tr>
                  <th *ngFor="let field of Fields">
                    {{ field?.label }}
                  </th>
                  <th>{{ KEY == 'USERS' ? 'Plan Access' : (KEY === 'B2B_CONTACTS' || KEY === 'B2B_NETWORKS') ? 'Access'
                    : 'Status' }}</th>
                </tr>

                <ng-container *ngFor="let item of userData; let i = index;">
                  <tr>
                    <td *ngFor="let field of Fields" style="position: relative;">

                      <ng-container *ngIf="field?.key === 'businessNetworks'; else normalField">
                        <div [attr.title]="getNetworksTitle(item[field?.key])" class="network-container"
                          *ngIf="item[field?.key]?.length > 0; else noNetworks">
                          <span class="ellipsis">{{ item[field?.key][0] }} </span>
                          <button *ngIf="item[field?.key]?.length > 1" class="network-count-box">
                            +{{ item[field?.key].length - 1 }}
                          </button>
                        </div>
                        <ng-template #noNetworks>
                          <span>N/A</span>
                        </ng-template>
                      </ng-container>
                      <ng-template #normalField>

                        <ng-container *ngIf="field?.route; else nonLinkField">
                          <a class="listinglink" [routerLink]="field?.path" [queryParams]="getParams(item)">
                            {{ item[field?.key] ? item[field?.key] : 'N/A' }}
                          </a>
                        </ng-container>

                        <ng-template #nonLinkField>
                          <div class="cell-flex" *ngIf="showCrownSvg(field, item)">
                            <div class="cell-item">
                              <ng-icon name="tablerCrown" class="cu-crown-icon"></ng-icon>
                            </div>
                            <div class="cell-item">
                              <label style="margin: 0;">
                                {{ item[field?.key] != null ? item[field?.key] : 'N/A' }}
                              </label>
                            </div>
                          </div>
                          <div *ngIf="!showCrownSvg(field, item)">


                            <label *ngIf="field?.key === 'teamName'">
                              <ng-container *ngIf="role !== 'EMPLOYEE' && role !== 'ADMIN'; else plainText">
                                <a class="listinglink" [routerLink]="['/user-management/workSpace/details']"
                                  [queryParams]="getWorkspaceParams(item)" routerLinkActive="router-link-active">
                                  {{ item[field?.key] != null ? item[field?.key] : 'N/A' }}
                                </a>
                              </ng-container>
                              <ng-template #plainText>
                                {{ item[field?.key] != null ? item[field?.key] : 'N/A' }}
                              </ng-template>
                            </label>

                            <label *ngIf="field?.key != 'teamName'">{{ item[field?.key] != null ? item[field?.key] :
                              'N/A' }}</label>

                          </div>
                        </ng-template>
                      </ng-template>

                    </td>

                    <td>
                      <label class="custom-switch" *ngIf="enableStatusToggle(item); else statusText">
                        <input class="statusBar" type="checkbox" [(ngModel)]="item.enabled" [disabled]="isSuperAdmin(i)"
                          (change)="onStatusChangeOfMember($event.target.checked, i)"
                          >
                        <span class="custom-slider"></span>
                      </label>

                      <ng-template #statusText>
                        {{ getStatusText(item) }}
                      </ng-template>
                    </td>

                  </tr>
                </ng-container>
              </table>
            </ng-container>

            <div class="p-4 text-center" *ngIf="userData != null && userData.length === 0">
              No data to display
            </div>

          </div>
        </div>
        <div class="col-sm-12 pl-1 end" *ngIf="superObj?.stopScroll && userData?.length > 0"
          style="text-align: center;padding-top: 1rem;">
          <div class="col-sm-12">
            <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
            <ng-icon name="tablerCircleCheck"></ng-icon>

          </div>
          <div class="col-sm-12">
            <p class="biase">You've reached the bottom of the page</p>
          </div>
        </div>
      </div>

      <!-- <div class="col-lg-12 text-right manage-template-footer">
                  <button class="btn btn-primary" (click)="updateMembersData()">Update</button>
              </div> -->
      <!-- </div> -->
    </div>
  </div>
</div>
<div class="manage-template-container">
  <mat-menu #menu="matMenu" xPosition="before" class="filter-panel-menu">
    <div class="filter-panel" (click)="$event.stopPropagation()">
      <div class="filter-panel-header">
        <span class="filter-panel-title">Filters</span>
        <button class="filter-clear-btn" *ngIf="hasActiveFilters()" (click)="clearAllFilters()">
          Clear all
        </button>
      </div>
      <div class="filter-panel-body">
        <ng-container *ngFor="let filterItem of dropdownContext; let i = index">
          <div class="filter-section">
            <div class="filter-section-title">{{ filterItem.label }}</div>
            <div class="filter-checkbox-list">
              <label class="filter-checkbox-item" *ngFor="let option of filterItem.options">
                <input type="checkbox"
                  [checked]="isFilterSelected(filterItem.payload, option.value)"
                  (change)="toggleFilter(filterItem.payload, option.value, $event, getMultiple(filterItem))" />
                <span class="filter-checkmark"></span>
                <span class="filter-label-text">{{ option.label }}</span>
              </label>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="filter-panel-footer">
        <button class="filter-cancel-btn" (click)="menu.close.emit()">Cancel</button>
        <button class="filter-apply-btn" (click)="saveFilter(); menu.close.emit()">
          Apply <span *ngIf="getActiveFilterCount() > 0">({{ getActiveFilterCount() }})</span>
        </button>
      </div>
    </div>
  </mat-menu>
</div>